import http from '@/uteis/http'

export default class ReservaProtocoloService {
  async buscarReservasProtocolo (filtro) {
    return new Promise((resolve, reject) => {
      http.get('/d0593/pae-back/v1/reservas', { params: filtro }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.get('/d0593/pae-back/v1/reservas', { params: filtro }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async buscarReservaProtocolo (idReservaProtocolo) {
    var url = `/d0593/pae-back/v1/reservas/${idReservaProtocolo}`
    return new Promise((resolve, reject) => {
      http.get(url).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.get(url).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async reservarProtocolo (values) {
    return new Promise((resolve, reject) => {
      http.post('/d0593/pae-back/v1/reservas', values).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.post('/d0593/pae-back/v1/reservas', values).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async excluirReservaProtocolo (id) {
    var url = `/d0593/pae-back/v1/reservas/${id}`
    return new Promise((resolve, reject) => {
      http.delete(url).then((response) => {
        return resolve(true)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.delete(url).then((response) => {
          return resolve(true)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }
}
